import { render, staticRenderFns } from "./UITView.vue?vue&type=template&id=1e0f540a&scoped=true&"
import script from "./UITView.vue?vue&type=script&lang=ts&"
export * from "./UITView.vue?vue&type=script&lang=ts&"
import style0 from "./UITView.vue?vue&type=style&index=0&id=1e0f540a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0f540a",
  null
  
)

export default component.exports